var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lyf-ui-action-icon",on:{"click":function($event){return _vm.iconClick($event)}}},[_c('lyf-icon',{attrs:{"icon":_vm.icon,"size":20,"color":_vm.color}}),_c('div',{staticClass:"lyf-ui-action-icon-text",style:({
    color: _vm.color
  })},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }